import { ApiClient } from '../../@sprinx/react-after-razzle';
import { SupportedLocale } from '../../supported';
import { ArticleDetail } from './Article';

export const getArticleDetail = (apiClient: ApiClient, locale: SupportedLocale, id: string): Promise<ArticleDetail> => {
  return apiClient.get<ArticleDetail, { id: string; locale: SupportedLocale }>('/v1/article/:id', { id, locale });
};
